import React, { ReactNode, FC } from 'react';

export const findChild = (children: ReactNode, component?: FC<any>): ReactNode | undefined => {
	return React.Children.toArray(children).find(
        (child: any) => {
        	return typeof child ==='object' && 'type' in child && child.type === component;}
	);
};

export const filterChildren = (children: ReactNode, component: FC<any>): ReactNode[] =>
	React.Children.toArray(children).filter(
        (child) => 
        	(typeof child !== 'object') || 
            !('type' in child) || 
            (child.type === component)
	);
